import React, { Children, cloneElement, FC, isValidElement, ReactNode } from 'react';

interface Props {
  value: any;
  onClick: (value: any) => void;
  children: ReactNode;
  className?: string;
}

export const Tabs: FC<Props> = ({ value, onClick, className = '', children }) => {
  return (
    <div className={`d-flex align-items-center flex-wrap ${className}`}>
      {Children.map(children, (child) => {
        if (!isValidElement(child)) {
          return child;
        }

        const props = {
          ...child.props,
          className: child.props.className || 'me-2',
          active: value === child.props.value,
          onClick,
        };

        return cloneElement(child, props);
      })}
    </div>
  );
};
